import styles from "./BaseHeader.module.scss";
import Hamburger from "./Hamburger.tsx";
import MyAccountButton from "./MyAccountButton.tsx";
import { clsx } from "clsx";
import BackButton from "./BackButton.tsx";
import { ReactNode } from "react";
import { HeaderTheme } from "./types.ts";
import StudentAccountBalanceButton from "./StudentAccountBalanceButton.tsx";
import StoreCartButton from "./StoreCartButton.tsx";

export interface BaseHeaderProps {
  theme?: HeaderTheme;
  backFallbackLocation?: string;
  bonusButtons?: ReactNode;
  className?: string;
  // Max content width, non-grid. Used to position Back button.
  maxWidth?: number;
  // Assumes a 3-column grid context. The top row is full width. The back button
  // is aligned with the center column.
  subgrid?: boolean;
}

export default function BaseHeader({
  theme,
  backFallbackLocation,
  bonusButtons,
  className,
  maxWidth,
  subgrid,
}: BaseHeaderProps) {
  return (
    <header
      className={clsx(
        styles.headerOuter,
        theme === "accent" && styles.accent,
        theme === "white" && styles.white,
        subgrid && styles.subgrid,
        className
      )}
    >
      <div className={styles.headerRow}>
        <div className={styles.leftSide}>
          <Hamburger theme={theme} />
        </div>
        <div className={styles.rightSide}>
          {bonusButtons}
          <StudentAccountBalanceButton theme={theme} />
          {/* There is also a My Courses compare and purchase cart button that
              can come in via bonusButtons. Brands should be configured to only allow one
              type of cart, but we'll show both if it's misconfigured. If it happens
              the resolution is probably to disable store search */}
          <StoreCartButton theme={theme} />
          <MyAccountButton theme={theme} />
        </div>
      </div>
      <div
        className={styles.backRow}
        style={{
          maxWidth,
        }}
      >
        {backFallbackLocation && (
          <BackButton to={backFallbackLocation} theme={theme} />
        )}
      </div>
    </header>
  );
}
